function renderTextareaFieldChangeHandlerTemplate({
  indent,
  defaultValueFromHandler
}: {
  indent: string
  defaultValueFromHandler: string
}): string {
  return `value={formField.value ?? ''}
${indent}          onChange={(event) => {
${indent}            ${defaultValueFromHandler}(event.target.value)
${indent}            formField.onChange(event)
${indent}          }}
${indent}          onBlur={formField.onBlur}
${indent}          name={formField.name}
${indent}          ref={formField.ref}`
}

function renderTextareaFieldFormFieldTemplate({
  indent,
  fieldName,
  fillFormItemProps,
  labelWithDescription,
  toLowerCase,
  fillControlClass,
  fieldProps
}: {
  indent: string
  fieldName: string
  fillFormItemProps: string
  labelWithDescription: string
  toLowerCase: string
  fillControlClass: string
  fieldProps: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${fillFormItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <Textarea
${indent}          placeholder="Enter ${toLowerCase}"
${indent}          className="${fillControlClass}"
${indent}          disabled={isPending}
${indent}          ${fieldProps}
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}

export function renderTextareaFieldRenderer(
  request:
    | {
        kind: 'renderTextareaFieldChangeHandlerTemplate'
        props: {
          indent: string
          defaultValueFromHandler: string
        }
      }
    | {
        kind: 'renderTextareaFieldFormFieldTemplate'
        props: {
          indent: string
          fieldName: string
          fillFormItemProps: string
          labelWithDescription: string
          toLowerCase: string
          fillControlClass: string
          fieldProps: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderTextareaFieldChangeHandlerTemplate':
      return renderTextareaFieldChangeHandlerTemplate(request.props)
    case 'renderTextareaFieldFormFieldTemplate':
      return renderTextareaFieldFormFieldTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
